import React from "react";
import { Sparkles } from "lucide-react";

/**
 * Bottone contestuale per aprire la chat di Olli da un punto qualsiasi della
 * dashboard, senza dover sollevare lo stato locale di OlliChat.jsx.
 * Dispatcha un evento globale 'olli:open' che OlliChat ascolta (vedi
 * src/components/ai/OlliChat.jsx) e apre la chat mantenendo un'unica fonte
 * di verità per lo stato "aperto/chiuso".
 */
export default function AskOlliButton({ darkMode = false, label = "Chiedi a Olli", className = "" }) {
  const handleClick = () => {
    window.dispatchEvent(new CustomEvent("olli:open"));
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${
        darkMode
          ? "bg-forfy-400/20 text-forfy-200 hover:bg-forfy-400/30"
          : "bg-forfy-100 text-forfy-700 hover:bg-forfy-200"
      } ${className}`}
    >
      <Sparkles className="w-3.5 h-3.5" />
      {label}
    </button>
  );
}
